<template>
  <b-modal
    :id="id"
    :ref="id"
    :title="title | i18n"
    :ok-title="'save' | i18n"
    :cancel-title="'Cancel' | i18n"
    ok-variant="primary"
    :ok-disabled="!chosenTeamId"
    cancel-variant="outline-secondary"
    button-size="lg"
    size="lg"
    centered
    content-class="rounded-8"
    @ok="save"
    @show="init"
    @hide="clear"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 mb-n4">
        <Select
          v-if="loaded"
          v-model="chosenTeamId"
          :options="teamsOptions"
          form-group-id="team"
          :placeholder="title | i18n"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../../../common/select';
import { ReportsMixin } from '../../../../../../mixins';

export default {
  name: 'ChooseTeam',
  components: { Select },
  mixins: [ReportsMixin],
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      teams: [],
      chosenTeamId: '',
      loaded: false,
    };
  },
  computed: {
    teamsOptions: function () {
      return this.teams.map((team) => ({ value: team.id, text: team.name }));
    },
  },
  methods: {
    async init() {
      this.loaded = false;
      const response = await this.reportsService.getTeams({
        page: 1,
        limit: 100,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
      });
      this.teams = response.data;
      this.loaded = true;
    },
    clear() {
      this.teams = [];
      this.chosenTeamId = '';
    },
    save() {
      const teamUsers = this.teams.flatMap((team) => {
        if (team.id === this.chosenTeamId) {
          return team.users.map((user) => ({
            value: user.id,
            text: `${user.name} ${user.email ? `(${user.email})` : ''}`,
          }));
        }

        return [];
      });

      this.onSubmit(teamUsers);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .modal-footer {
  justify-content: space-between;
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 130px;
    padding-left: 130px;
    margin: 0;
  }
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>